import React, { useState, useEffect, useContext, useMemo } from "react";
import {
  CustomSelect,
} from "components/Input/Index.js";
import Button from "components/CustomButtons/Button.js";
import EditButton from "components/CustomButtons/Button.js";
import { makeStyles, withStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import uuid from "react-uuid";
import DateInput from "components/Input/DateInput.js";
import IntInput from "components/Input/IntInput.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { categorypage } from "variables/tertiaryBill";
import { categoriesdata, subcategoriesdata } from "variables/lists/tertiarybill";
import DataTable from "react-data-table-component";
import _ from "lodash";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import IndicatorEditionDialog from "./IndicatorEditionDialog";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const useStyles2 = makeStyles(styles);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "12ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "12ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;
const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;
const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

function CategoryEditionDialog(props) {
  const memv2versionactive = localStorage.getItem('memv2version') || 0;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const { closeModal, refetch, setLoading, currentCategory, categories, setCategories, handleEdit } = props;

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = advancedSearchContext;

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [category, setCategory] = useState(currentCategory?.category || "CAP01");
  const [subcategory, setSubcategory] = useState(currentCategory?.subcategory || "");
  const [surface, setSurface] = useState(currentCategory?.surface || "");
  const [datebegin, setDatebegin] = useState(currentCategory?.datebegin || "");
  const [dateend, setDateend] = useState(currentCategory?.dateend || "");
  const [heating, setHeating] = useState(currentCategory?.heating || "");
  const [cooling, setCooling] = useState(currentCategory?.cooling || "");
  const [coollog, setCoollog] = useState(currentCategory?.coollog || "");
  const [coolcom, setCoolcom] = useState(currentCategory?.coolcom || "");
  const [consdoc, setConsdoc] = useState(currentCategory?.consdoc || "");

  const [indicators, setIndicators] = useState(currentCategory?.indicators || []);
  const [currentIndicator, setCurrentIndicator] = useState("");
  const [openindicator, setOpenindicator] = useState(false);

  const handleCategoryChange = (event) => {
    setCategory(event.target.value);
    setSubcategory("");
  };
  const handleSubcategoryChange = (event) => { setSubcategory(event.target.value); };
  const handleSurfaceChange = (event) => { setSurface(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleHeatingChange = (event) => { setHeating(!heating); };
  const handleCoolingChange = (event) => { setCooling(!cooling); };
  const handleCoollogChange = (event) => { setCoollog(!coollog); };
  const handleCoolcomChange = (event) => { setCoolcom(!coolcom); };
  const handleConsdocChange = (event) => { setConsdoc(!consdoc); };


  const classes = useStyles();
  const classes2 = useStyles2();

  const handleSubmit = (event) => {
    let obj = categories.find((o) => o.uuid === currentCategory.uuid);
    if (obj) //edition
    {
      obj.category = category;
      obj.subcategory = subcategory;
      obj.surface = surface;
      obj.datebegin = datebegin;
      obj.dateend = dateend;
      obj.heating = heating;
      obj.cooling = cooling;
      obj.coollog = coollog;
      obj.coolcom = coolcom;
      obj.consdoc = consdoc;
      obj.indicators = indicators;
      handleEdit(categories);
    }
    else //ajout
    {
      let newCategory = {
        uuid: uuid(),
        category: category,
        subcategory: subcategory,
        surface: surface,
        datebegin: datebegin,
        dateend: dateend,
        heating: heating,
        cooling: cooling,
        coollog: coollog,
        coolcom: coolcom,
        consdoc: consdoc,
        indicators: indicators,
      };
      let tmpdata = [...categories];
      tmpdata.push(newCategory);
      setCategories(tmpdata);
      handleEdit(tmpdata);
    }
  };

  useEffect(() => {
    if (!category)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  const indicatorscolumns = [
    {
      name: categorypage.indicatorname,
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => row.name
    },
    {
      name: categorypage.indicatorvalue,
      selector: (row) => row.value,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.value
    },
    {
      name: "",
      sortable: false,
      width: "8rem",
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title={categorypage.editindicator}>
              <EditButton
                onClick={editindicator(row)}
                color={"warning"}
                className={classes2.actionButtonDense}
              >
                <EditIcon fontSize="large" />
              </EditButton>
            </Tooltip>
            <Tooltip title={categorypage.deleteindicator}>
              <EditButton
                onClick={deleteindicator(row)}
                color={"danger"}
                className={classes2.actionButtonDense}
              >
                <DeleteIcon fontSize="large" />
              </EditButton>
            </Tooltip>
          </div>
        </>
      ),
    },
  ]



  const handleClickOpenIndicator = () => {
    setOpenindicator(true);
  };
  const handleEditCloseIndicator = () => {
    if (!currentIndicator.name)
      currentIndicator.name = 'Nouvel indicateur';
    if (!currentIndicator.value)
      currentIndicator.value = 0;
    setOpenindicator(false);
  };

  const editindicator = (row) => async () => {
    let obj = indicators.find((o) => o.uuid === row.uuid);
    if (obj) {
      setCurrentIndicator(obj);
      handleClickOpenIndicator();
    }
  }
  const deleteindicator = (row) => async () => {
    let obj = indicators.find((o) => o.uuid === row.uuid);
    if (obj) {
      let newindicators = [...indicators];
      newindicators = newindicators.filter((o) => o.uuid !== row.uuid);
      setIndicators(newindicators);
    }

  };

  const AddIndicator = () => {
    let newIndicator = {
      uuid: uuid(),
      name: 'Nouvel indicateur',
      value: 0,
    };
    let tmpdata = [...indicators];
    tmpdata.push(newIndicator);
    setIndicators(tmpdata);
    setCurrentIndicator(newIndicator);
    handleClickOpenIndicator();
  };

  const subHeaderComponentMemoIndicator = useMemo(() => {
    const handleClearIndicator = () => {
    };
    return (
      <>
        <TableName>Indicateurs</TableName>
        <UploadButton type="button" onClick={handleClearIndicator}>
          <Tooltip title={categorypage.addindicator}>
            <Button
              onClick={AddIndicator}
              color={"success"}
              className={classes2.actionButton}
            >
              <AddIcon fontSize="large" />
            </Button>
          </Tooltip>
        </UploadButton>

      </>
    );
  }, [indicators, currentCategory]);

  return (
    <>
      <CustomDialogTitle id="customized-dialog-title" onClose={closeModal}>
        {currentCategory.uuid ? 'Edition de la catégorie ' + category : "Ajout d'une catégorie"}
      </CustomDialogTitle>
      <DialogContent dividers>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div>
              <CustomSelect
                isRequired
                inputTitle={categorypage.category}
                selectValue={category}
                handleSelectValueChange={handleCategoryChange}
                data={categoriesdata}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={categorypage.subcategory}
                selectValue={subcategory}
                handleSelectValueChange={handleSubcategoryChange}
                data={subcategoriesdata.filter((obj) => obj.category === category)}
              />
            </div>
            <div>
              <IntInput
                inputTitle={categorypage.surface}
                intInput={surface}
                handleIntInputChange={handleSurfaceChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={categorypage.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={categorypage.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={categorypage.heating}
                checkedState={heating}
                handleSwitchChange={handleHeatingChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={categorypage.cooling}
                checkedState={cooling}
                handleSwitchChange={handleCoolingChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={categorypage.coollog}
                checkedState={coollog}
                handleSwitchChange={handleCoollogChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={categorypage.coolcom}
                checkedState={coolcom}
                handleSwitchChange={handleCoolcomChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={categorypage.consdoc}
                checkedState={consdoc}
                handleSwitchChange={handleConsdocChange}
              />
            </div>
          </GridItem>

          <GridItem xs={12} sm={12} md={12}>
            <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
              noDataComponent={<NoData>{"Aucun indicateur"}</NoData>}
              noHeader={true}
              columns={indicatorscolumns}
              persistTableHead
              pagination
              subHeader
              data={indicators}
              paginationComponentOptions={{
                noRowsPerPage: false,
                rowsPerPageText: "Lignes par page",
                rangeSeparatorText: "sur",
                selectAllRowsItem: false,
                selectAllRowsItemText: "Selectionner toutes les lignes",
              }}
              defaultPageSize={5}
              filterable={true}
              defaultSortFieldId={1}
              manual={true}
              subHeaderComponent={subHeaderComponentMemoIndicator}
              dense
            />
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Valider
        </Button>
      </DialogActions>
      <Dialog
        onClose={handleEditCloseIndicator}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={openindicator}
      >
        <IndicatorEditionDialog
          currentIndicator={currentIndicator}
          closeModal={handleEditCloseIndicator}
        />
      </Dialog>
    </>
  );
}

export default CategoryEditionDialog;
